import request from './request'

const onlineActionApi = {
  saveOnlineAction (data) {
    return request.post('/onlineAction', data)
  },
  updateOnlineAction (id, data) {
    return request.put('/onlineActions/' + id, data)
  },
  deleteOnlineAction (id) {
    return request.delete('/onlineActions/' + id)
  },
  listOnlineAction (params) {
    return request.get('/onlineActionsV2', { params })
  },
  getOnlineAction (id) {
    return request.get('/onlineActionsV2/' + id)
  },
}

export default onlineActionApi
